import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import PCLayout from '../../PCLayout';

const ActivitiesDetailPage = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);

    useEffect(() => {
        fetch('/data/activities.json')
            .then(response => response.json())
            .then(data => setActivities(data.sort((a, b) => b.id - a.id)))
            .catch(error => console.error('Error fetching activities data:', error));
    }, []);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (selectedActivity) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedActivity]);

    const openModal = (activity) => {
        setSelectedActivity(activity);
    };

    const closeModal = () => {
        setSelectedActivity(null);
    };

    const handleBack = () => {
        navigate('/prof', { state: { targetSection: 'activities' } });
    };

    return (
        <PCLayout
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
            activePage="activities"
        >

            <div className="detailPageContent">
                <div className="inlineBackButtonContainer">
                    <button onClick={handleBack} className="inlineBackButton">
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                <div className="cardGrid">
                    {activities.map((activity) => (
                        <div className="card experienceCard" key={activity.id} onClick={() => openModal(activity)}>
                            <h3 className="cardTitle">{activity.title}</h3>
                            <span className="cardDate">{activity.period}</span>

                            <p className="cardDescription">
                                {activity.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {selectedActivity && (
                <div className="modalOverlay" onClick={closeModal}>
                    <div className="detailModalContent" onClick={(e) => e.stopPropagation()}>
                        <button className="detailModalClose" onClick={closeModal}>&times;</button>
                        <div className="detailModalHeader">
                            <h2 className="detailModalTitle">{selectedActivity.title}</h2>
                            <span className="detailModalDate">{selectedActivity.period}</span>
                        </div>
                        <div className="detailModalBody">
                            <p className="detailModalText" style={{ marginBottom: '1.5rem' }}>
                                {selectedActivity.description}
                            </p>
                        </div>
                    </div>
                </div>
            )}

        </PCLayout>
    );
};

export default ActivitiesDetailPage;
